<template>
    <div class="wrap-data-user">
        <div class="container-detail-input">
            <div class="data-pribadi-print">
                <h5>Data Pribadi</h5>
                <div class="form-group">
                    <label for="">Nama Lengkap </label>
                    <span>:</span>
                    <span>{{ dataPribadi.fullname }}</span>
                </div>
                <!-- <div class="form-group">
              <label for="">Nama Panggilan</label>
              <span>:</span>
              <span>{{ dataPribadi.nickname }}</span>
            </div> -->
                <div class="form-group">
                    <label for="">Tempat/ tanggal lahir </label>
                    <span>:</span>
                    <span>{{ dataPribadi.place_of_birth }}, {{ dataPribadi.date_of_birth | formatDate }}</span>
                </div>
                <div class="form-group">
                    <label for="">No Identitas </label>
                    <span>:</span>
                    <span>( KTP ) {{ dataPribadi.ktp_no }}</span>
                </div>
                <div class="form-group">
                    <label for="">NPWP </label>
                    <span>:</span>
                    <span>{{ dataPribadi.npwp_no }}</span>
                </div>
                <!-- <div class="form-group">
              <label for="">Kewarganegaraan </label>
              <span>:</span>
              <span>{{ dataPribadi.citizenship }}</span>
            </div> -->
                <div class="form-group">
                    <label for="">Alamat sesuai KTP </label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.address : "" }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Provinsi </label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.province : "" }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Kota </label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.regency : "" }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Kecamatan </label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.district : "" }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Kelurahan </label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.village : "" }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">RT/RW </label>
                    <span>:</span>
                    <span
                        >{{ dataPribadi.identity_address ? dataPribadi.identity_address.neighborhood_no : "" }} /
                        {{ dataPribadi.identity_address ? dataPribadi.identity_address.citizen_no : "" }}</span
                    >
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Kodepos </label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.postcode : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">No Telepon Rumah </label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.telephone : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Jenis Kelamin </label>
                    <span>:</span>
                    <span>{{ dataPribadi.gender_type ? dataPribadi.gender_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Setatus Perkawinan </label>
                    <span>:</span>
                    <span>{{ dataPribadi.marriage_type ? dataPribadi.marriage_type.name : "" }}</span>
                </div>
                <div class="form-group" v-show="dataPribadi.marriage_type.name == 'Menikah'">
                    <label for="">Nama suami/istri</label>
                    <span>:</span>
                    <span>{{ dataPribadi.partners_name }}</span>
                </div>
                <div class="form-group">
                    <label for="">Nama ibu kandung</label>
                    <span>:</span>
                    <span>{{ dataPribadi.mothers_name }}</span>
                </div>
                <div class="form-group">
                    <label for="">Status Kepemilikan Rumah</label>
                    <span>:</span>
                    <span>{{ dataPribadi.identity_address ? dataPribadi.identity_address.ownership_status : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Tujuan Pembukaan Rekening</label>
                    <span>:</span>
                    <span>{{ dataPribadi.purpose_open_account_type ? dataPribadi.purpose_open_account_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Pengalaman Investasi</label>
                    <span>:</span>
                    <span>{{ dataPribadi.has_investment_experience ? "Pernah" : "Tidak" }}</span>
                </div>
                <div class="data-kontak-print">
                    <h5>Data Kontak Darurat</h5>
                    <div class="form-group">
                        <label for="">Nama</label>
                        <span>:</span>
                        <span>{{ dataEmergency.fullname }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Alamat</label>
                        <span>:</span>
                        <span>{{ dataEmergency.address }}</span>
                    </div>
                    <div class="form-group">
                        <label>Kodepos</label>
                        <span>:</span>
                        <span>{{ dataEmergency.postcode }}</span>
                    </div>
                    <div class="form-group">
                        <label>No Telepon</label>
                        <span>:</span>
                        <span>{{ dataEmergency.phonenumber }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Hubungan anda</label>
                        <span>:</span>
                        <span>{{ dataEmergency.relationship }}</span>
                    </div>
                </div>
                <div class="data-info-print">
                    <h5>Data Info Akun</h5>
                    <div v-for="(infoAcount, i) in dataTradeAcount" :key="i">
                        <div>
                            <p v-if="infoAcount.platform == 'BEI05001'">Jafets Now</p>
                            <p v-if="infoAcount.platform == 'BEI05002'">GOFX</p>
                        </div>
                        <div class="form-group">
                            <label for="">Username</label>
                            <span>:</span>
                            <span>{{ infoAcount.username }}</span>
                        </div>
                        <div class="form-group">
                            <label for="">Password</label>
                            <span>:</span>
                            <span>{{ infoAcount.password }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-pekerjaan-print">
                <h5>Data Pekerjaan</h5>
                <div class="form-group">
                    <label for="">Pekerjaan</label>
                    <span>:</span>
                    <span v-if="dataWork.other_occupation">{{ dataWork.other_occupation }}</span>
                    <span v-else>{{ dataWork.occupation_type ? dataWork.occupation_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Nama perusahaan</label>
                    <span>:</span>
                    <span>{{ dataWork.company_name }}</span>
                </div>
                <div class="form-group">
                    <label for="">Alamat Perusahaan</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.address }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Provinsi</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.province }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Kota</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.regency }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Kecamatan</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.district }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Kelurahan</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.village }}</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">RT/RW </label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.neighborhood_no }} / {{ dataWork.company_address.citizen_no }}</span>
                </div>
                <div class="form-group">
                    <label>Kodepos</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.postcode }}</span>
                </div>
                <div class="form-group">
                    <label>No Telepon perusahaan</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.telephone }}</span>
                </div>
                <div class="form-group">
                    <label>No faksimail perusahaan</label>
                    <span>:</span>
                    <span>{{ dataWork.company_address.fax }}</span>
                </div>
                <div class="form-group">
                    <label for="">Bidang usaha</label>
                    <span>:</span>
                    <span v-if="dataWork.business_sector">{{ dataWork.business_sector }}</span>
                    <span v-else>{{ dataWork.industrial_type ? dataWork.industrial_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Jabatan</label>
                    <span>:</span>
                    <span v-if="dataWork.other_position">{{ dataWork.other_position }}</span>
                    <span v-else>{{ dataWork.position_type ? dataWork.position_type.name : "" }}</span>
                </div>
                <div class="form-group">
                    <label for="">Lama pekerjaan</label>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Saat ini</label>
                    <span>:</span>
                    <span>{{ dataWork.work_year }}</span>
                    <span class="tahun">Tahun</span>
                    <span>{{ dataWork.work_month }}</span>
                    <span class="tahun">Bulan</span>
                </div>
                <div class="form-group">
                    <label class="detail-alamat">Perusahaan sebelumnya</label>
                    <span>:</span>
                    <span>{{ dataWork.work_year_previous }}</span>
                    <span class="tahun">Tahun</span>
                </div>
                <div class="data-keuangan-print">
                    <h5>Data Keuangan</h5>
                    <div class="form-group">
                        <label for="">Penghasilan</label>
                        <span>:</span>
                        <span>{{ dataFinance.salary_type ? dataFinance.salary_type.name : "" }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Lokasi rumah</label>
                        <span>:</span>
                        <span>{{ dataFinance.wealth_list.home_location }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Nilai NJOP</label>
                        <span>:</span>
                        <span>{{ dataFinance.wealth_list.njop_value }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Deposit Bank</label>
                        <span>:</span>
                        <span>{{ dataFinance.wealth_list.deposit }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Jumlah</label>
                        <span>:</span>
                        <span>{{ dataFinance.wealth_list.total_deposit }}</span>
                    </div>
                    <div class="form-group">
                        <label for="">Lainnya</label>
                        <span>:</span>
                        <span>{{ dataFinance.wealth_list.other }}</span>
                    </div>
                </div>
                <div class="data-rekening-print">
                    <h5>Data Rekening</h5>
                    <div class="form-group">
                        <label>Nama bank</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].name }}</span>
                    </div>
                    <div class="form-group">
                        <label>No Rekening</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].account_no }}</span>
                    </div>
                    <div class="form-group">
                        <label>Cabang</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].branch }}</span>
                    </div>
                    <div class="form-group">
                        <label>Telepon</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].phonenumber }}</span>
                    </div>
                    <div class="form-group">
                        <label>Jenis Rekening</label>
                        <span>:</span>
                        <span>{{ dataCustomer[0].type_account }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dataPribadi: Object,
        dataEmergency: Object,
        dataWork: Object,
        dataFinance: Object,
        dataCustomer: Array,
        dataTradeAcount: Array,
    },
};
</script>

<style scoped>
.wrap-data-user {
    min-height: 277mm;
    /* padding: 10mm; */
    /* margin: 10mm auto; */
    /* border: 1px #d3d3d3 solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.container-detail-input {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    width: 90%;
    margin: 0 auto;
}

.container-detail-input .form-group {
    margin-bottom: 0.5rem;
    font-size: 12px;
}

.container-detail-input .form-group label {
    width: 135px;
    font-weight: normal;
}
.container-detail-input .form-group .detail-alamat {
    width: 105px;
}

.container-detail-input .data-pekerjaan-print {
    flex: 1;
}

.container-detail-input .data-pribadi-print {
    flex: 1;
}

.detail-alamat {
    width: 145px;
    margin: 0 0 0 30px;
}
.data-pribadi .detail-alamat {
    flex: 0.82 !important;
}

@media (max-width: 768px) {
    .container-detail-input {
        flex-direction: column;
    }

    .container-detail-input .form-group label {
        width: 160px;
    }

    .container-detail-input .form-group .detail-alamat {
        margin: unset;
        width: 160px;
    }
}
</style>
